<template>
  <div>
    <el-skeleton :loading="loading" animated>
      <template slot="template">
        <header class="site-header">
          <div class="header-area">
            <div class="wrap">
              <div class="header-top">
                <div class="l-area">
                  <h1 class="logo"><router-link to="/main">건강기능식품·수입식품 교육센터</router-link></h1>
                  <span class="logo-label">식품의약품안전처 지정 위생교육기관</span>
                </div>
                <div class="r-area">
                  <div class="util">
                    <!-- 로그인 전 -->
                    <div class="btn-group">
                      <router-link to="/login" class="btn-sm spot3" @click.native="closeNav">로그인</router-link>
                    </div>
                    <router-link to="/signup/term" class="btn-sm spot2" @click.native="closeNav">회원가입</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-skeleton-item style="height: 5vh; margin-top: 5px" />
              <el-skeleton-item style="height: 30vh" />
              <el-skeleton-item style="height: 7vh" />
              <el-skeleton-item style="width: 49vw; height: 20vh; float: left" />
              <el-skeleton-item style="width: 49vw; height: 20vh; float: right" />
              <el-skeleton-item style="height: 7vh; margin-top: 10px" />
            </div>
          </div>
        </header>
      </template>
      <template>
        <header class="site-header">
          <div class="header-area">
            <div class="wrap">
              <div class="header-top">
                <div class="l-area">
                  <h1 class="logo"><router-link to="/main">건강기능식품·수입식품 교육센터</router-link></h1>
                  <span class="logo-label">식품의약품안전처 지정 위생교육기관</span>
                </div>
                <div class="r-area">
                  <div class="util" v-if="currentUser?.isAuthenticated">
                    <span class="user">
                      <strong>{{ currentUser.userNm }}</strong>
                      님 접속중
                    </span>
                    <div class="btn-group">
                      <router-link to="/mypage/info" class="btn-txt" @click.native="closeNav"><strong>개인정보수정</strong></router-link>
                      <a
                        @click="
                          setLogout();
                          closeNav();
                        "
                        class="btn-txt">
                        로그아웃
                      </a>
                    </div>
                  </div>
                  <div class="util" v-if="!currentUser?.isAuthenticated">
                    <!-- 로그인 전 -->
                    <div class="btn-group">
                      <router-link to="/login" class="btn-sm spot3" @click.native="closeNav">로그인</router-link>
                    </div>
                    <router-link to="/signup/term" class="btn-sm spot2" @click.native="closeNav">회원가입</router-link>
                  </div>
                </div>
              </div>
              <nav class="site-gnb">
                <SiteHeader ref="siteHeader"></SiteHeader>
              </nav>
              <button type="button" class="btn-nav-open">
                <span class="txt-hide">전체보기 열기</span>
              </button>
            </div>
            <div class="site-nav-area">
              <div class="wrap">
                <div class="site-nav">
                  <div class="nav-header">
                    <div class="nav-util" v-if="currentUser?.isAuthenticated">
                      <span class="user">
                        <strong>{{ currentUser.userNm }}</strong>
                        님 접속중
                      </span>
                      <div class="btn-group">
                        <router-link to="/mypage/info" class="btn-txt" @click.native="closeNav"><strong>개인정보수정</strong></router-link>
                        <a
                          @click="
                            setLogout();
                            closeNav();
                          "
                          class="btn-txt">
                          로그아웃
                        </a>
                      </div>
                    </div>

                    <div class="nav-util" v-if="!currentUser?.isAuthenticated">
                      <!-- 로그인 전 -->
                      <div class="btn-group">
                        <router-link to="/login" class="btn-sm spot3" @click.native="closeNav">로그인</router-link>
                      </div>
                      <router-link to="/signup/term" class="btn-sm spot2" @click.native="closeNav">회원가입</router-link>
                    </div>
                  </div>

                  <SiteHeader ref="siteHeader2"></SiteHeader>

                  <button type="button" class="btn-nav-close">
                    <span class="txt-hide">전체보기 닫기</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div class="site-body">
          <div class="sub-top" v-if="$route.meta.layout != null && $route.meta.layout.name != 'MainLayout'">
            <div class="wrap">
              <h2 v-if="menuMap != null">{{ menuMap.text }}</h2>
              <ul class="location">
                <li>
                  <router-link to="/main" class="home">홈</router-link>
                </li>
                <li v-for="item in locMenuList" :key="item.id">
                  <a :href="menuHref(item)" @click.prevent="goMenu(item)">{{ item.text }}</a>
                </li>
              </ul>
              <ul class="lnb">
                <li v-for="item in subMenuList" :key="item.id">
                  <a :href="menuHref(item)" @click.prevent="goMenu(item)" :class="item.id == parseInt(menuMap.id) ? 'is-active' : ''">{{ item.text }}</a>
                </li>
              </ul>
            </div>
          </div>

          <component :is="$route.meta.layout || 'MainLayout'">
            <router-view />
          </component>
        </div>

        <footer class="site-footer" v-if="!isApp()">
          <SiteFooter></SiteFooter>
        </footer>

        <div class="dim"></div>
      </template>
    </el-skeleton>
  </div>
</template>

<style>
a:hover {
  cursor: pointer;
}
</style>
<script>
import { apiURL, siteURL } from "@/utils";
import { mapGetters } from "vuex";
import "@/static/css/element-ui.css";
import SiteHeader from "@/layout/SiteHeader";
import SiteFooter from "@/layout/SiteFooter";
import MainLayout from "@/layout/MainLayout";
import SubLayout from "@/layout/SubLayout";
import router from "@/router";
import { defualtMeta } from "@/utils/meta";
import { suppressDeprecationWarnings } from "moment";

export default {
  name: "App",
  components: {
    SiteHeader,
    SiteFooter,
    MainLayout,
    SubLayout,
    router,
  },
  data() {
    return {
      menuId: 0,
      menuList: [],
      loading: true,
      menuMap: {},
      subMenuList: [],
      locMenuList: [],
      currentMenuId: 0,
      parentMenuId: 0,
      isMobileApp: false,
      debounceTimer: null,
    };
  },
  metaInfo: {
    titleTemplate: (titleChunk) => {
      return titleChunk;
    },
    meta: defualtMeta,
  },
  created() {
    if (process.env.NODE_ENV === "development") {
      const el = document.querySelector("meta[name=viewport]");
      if (el !== null) {
        let content = el.getAttribute("content");
        let re = /maximum\-scale=[0-9\.]+/g;
        if (re.test(content)) {
          content = content.replace(re, "maximum-scale=1.0");
        } else {
          content = [content, "maximum-scale=1.0"].join(", ");
        }
        el.setAttribute("content", content);
      }

      this.loadJs(siteURL + "/assets/js/user/jquery-ui.min.js");
      this.loadJs(siteURL + "/assets/js/user/jquery.easing.1.3.js");
      this.loadJs(siteURL + "/assets/js/user/ssm.min.js");
      this.loadJs(siteURL + "/assets/js/user/slick.js");
      this.loadJs(siteURL + "/assets/js/user/TweenMax.min.js");
      this.loadJs(siteURL + "/assets/js/user/ScrollMagic.min.js");
      this.loadJs(siteURL + "/assets/js/user/animation.gsap.min.js");

      // jQuery 플러그인 로드 후 전역 플래그 설정
      const commonScript = this.loadJs(siteURL + "/assets/js/user/common2026.js", false);
      commonScript.onload = () => {
        window.jQueryPluginsLoaded = true;
      };

      this.loadJs("//wcs.naver.net/wcslog.js");
      this.loadCss(siteURL + "/assets/css/user/style2026.css");
    }
  },
  mounted() {
    this.checkSession();
    this.getMenuList();
    this.$nextTick(() => {
      this.initPageScripts();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        // console.log("bye");
      } else {
        // console.log("welcome");
        //this.$store.dispatch("getCheckSession").then(() => {});
      }
    });

    var self = this;
    let lastCheckSessionTime = 0;
    const CHECK_SESSION_INTERVAL = 5 * 60 * 1000; // 5분 이내 중복 호출 방지
    window.addEventListener("focus", (event) => {
      // console.log(`Event: ${event.type}`);
      if (this.currentUser == null || this.currentUser.userId == null) return;
      const now = Date.now();
      if (now - lastCheckSessionTime < CHECK_SESSION_INTERVAL) return;
      lastCheckSessionTime = now;
      self.$store.dispatch("getCheckSession").then(() => {});
    });
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser", "currentMenu"]),
  },
  watch: {
    $route: function (to, from) {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
      this.currentMenuId = localStorage.getItem("MENU");
      this.getMenuInfo();
    },
    currentMenu: {
      immediate: true,
      handler(value) {
        localStorage.setItem("FMENU", value);
        this.getMenuInfo();
      },
    },
  },
  methods: {
    checkSession() {
      if (this.currentUser == null || this.currentUser.userId == null) return;
      this.$nextTick(() => {
        this.$store.dispatch("getCheckSession").then(() => {});
      });
    },
    setRetriveSession() {
      this.$store.dispatch("setSessionRetrive", {});
    },
    closeNav() {
      $(".btn-nav-close").trigger("click");
    },
    setLogout() {
      this.$store.dispatch("setLogout", this.resultMap).then(() => {
        this.$nextTick(() => {
          this.$router.push({ path: "/main" }).catch(() => {});
        });
      });
    },
    // 검색엔진은 href 가 있는 <a> 만 링크로 따라간다. 라우팅은 goMenu 가 그대로 처리한다.
    menuHref(item) {
      const url = item.url?.replace(/^\/usr/, "") || item.url;
      return url ? this.$router.resolve(url).href : undefined;
    },
    goMenu(item) {
      localStorage.setItem("MENU", item.id);
      const url = item.url?.replace(/^\/usr/, "") || item.url;
      this.$router.push(url).catch(() => {});
    },
    getMenuList() {
      this.loading = true;
      return this.request(`${apiURL}/menu/header`).then((result) => {
        if (result.headers["isauthenticated"] && result.config.headers["X-Auth-Token"] == null) {
          // 실제 세션은 살아 있지만, currentUser가 비어 있을 경우 다시 세션 정보 가져오기
          this.setRetriveSession();
        }

        var data = result.data;
        this.setMenuUrlChange(data.menuList.children);

        data.menuList.children.push({
          text: "로그인",
          url: "/login",
          id: 980,
          parentId: 99,
          path: "/980",
          type: "folder",
          order: 1,
          level: 2,
        });
        data.menuList.children.push({
          text: "아이디/비밀번호찾기",
          url: "/login/find",
          id: 981,
          parentId: 99,
          path: "/981",
          type: "folder",
          order: 2,
          level: 2,
        });
        data.menuList.children.push({
          text: "회원가입",
          url: "/signup/term",
          id: 982,
          parentId: 99,
          path: "/982",
          type: "folder",
          order: 3,
          level: 2,
        });

        data.menuList.children.push({
          text: "이용안내",
          url: "/intro/legal",
          id: 983,
          parentId: 98,
          path: "/983",
          type: "folder",
          order: 3,
          level: 2,
        });
        data.menuList.children.push({
          text: "개인정보처리방침 ",
          url: "/intro/privacy",
          id: 984,
          parentId: 98,
          path: "/984",
          type: "folder",
          order: 3,
          level: 2,
        });
        data.menuList.children.push({
          text: "이메일 무단수집 거부",
          url: "/intro/emailprivacy",
          id: 985,
          parentId: 98,
          path: "/985",
          type: "folder",
          order: 3,
          level: 2,
        });

        data.menuList.children.push({
          text: "이메일 무단수집 거부",
          url: "/intro/emailprivacy",
          id: 986,
          parentId: 98,
          path: "/986",
          type: "folder",
          order: 1,
          level: 2,
        });

        this.menuList = data.menuList || [];

        this.getMenuInfo();
        this.loading = false;

        this.$nextTick(() => {
          this.$refs.siteHeader.setMenuList(data.menuList);
          this.$refs.siteHeader2.setMenuList(data.menuList);
        });
      });
    },
    setMenuUrlChange(data) {
      const base = (this.$router.options.base || "").replace(/\/$/, "");

      data.map((item) => {
        if (item.id == "211") item.url = `/crse`;
        if (item.id == "2112") item.url = `/crse/1003`;
        if (item.id == "212") item.url = `/enroll/intro`;
        if (item.id == "213") item.url = `/myclass`;
        if (item.id == "327") item.url = `/enroll/search`;
        if (item.id == "215") item.url = `/bbs/10005`;
        if (item.id == "216") item.url = `/mypage`;

        if (item.id == "217") item.url = `/crse/1003`;
        if (item.id == "337") item.url = `/crse/1006`;
        if (item.id == "374") item.url = `/crse/law`;

        if (item.id == "222") item.url = `/enroll/step1/1005`;
        if (item.id == "223") item.url = `/enroll/step1/1006`;
        if (item.id == "224") item.url = `/enroll/step1/1006`;

        if (item.id == "225") item.url = `/myclass`;
        if (item.id == "368") item.url = `/mypage`;

        if (item.id == "370") item.url = `/myclass/cert`;
        if (item.id == "372") item.url = `/myclass/agent`;

        if (item.id == "373") item.url = `/enroll/search`;

        if (item.id == "232") item.url = `/bbs/10005`;
        if (item.id == "345") item.url = `/bbs/10030`;
        if (item.id == "234") item.url = `/bbs/10007`;
        if (item.id == "233") item.url = `/bbs/faq/10006`;
        if (item.id == "235") item.url = `/bbs/10008`;

        if (item.id == "237") item.url = `/mypage/info`;

        // API URL에서 router base prefix 제거 (예: /usr/enroll/intro → /enroll/intro)
        if (base && item.url && item.url.startsWith(base + "/")) {
          item.url = item.url.slice(base.length);
        }

        if (item.children != null) {
          this.setMenuUrlChange(item.children);
        }
      });
    },
    getMenuInfo() {
      if (this.menuList.children != null) {
        this.getMenu();
        this.getSubMenu();
      }
    },
    getSubMenu() {
      this.subMenuList = [];
      if (this.menuMap != null) {
        this.getFindChildMenu(this.menuList.children, this.menuMap.parentId, this.subMenuList);
      }
    },
    getMenu() {
      this.menuMap = {};
      this.locMenuList = [];

      // console.log("FMENU", localStorage.getItem("FMENU"));
      if (localStorage.getItem("FMENU") != null && localStorage.getItem("FMENU") != "null") {
        // console.log("FMENU", localStorage.getItem("FMENU"));
        this.menuMap = this.getFindMenu(this.menuList.children, "id", localStorage.getItem("FMENU"));

        this.$store.dispatch("removeCurrentMenu");
      } else {
        this.menuMap = this.getFindMenu(this.menuList.children, "path", this.$route.path);
        if (this.menuMap == null) {
          this.menuMap = this.getFindMenu(this.menuList.children, "id", localStorage.getItem("MENU"));
        }
      }

      if (this.menuMap == null) {
        return;
      }

      localStorage.setItem("MENU", this.menuMap.id);

      if (this.menuMap != null && this.menuMap.path != null) {
        var menuPath = this.menuMap.path.split("/");
        menuPath.map((item) => {
          if (item != null && item != "") {
            var locMenu = this.getFindMenu(this.menuList.children, "id", item);
            if (locMenu != null) this.locMenuList.push(locMenu);
          }
        });
      }
    },
    getFindMenu(menu, type, compareId) {
      if (!menu) return null;
      for (const item of menu) {
        // 1. ID 매칭
        if (type == "id" && parseInt(item.id) == parseInt(compareId)) {
          return item;
        }
        // 2. Path 매칭
        if (type == "path" && item.level > 1) {
          if (item.url == compareId) {
            return item;
          }
          // 패턴 매칭 (예: /comp/promo/{id})
          if (item.url && item.url.indexOf("{") > -1) {
            const pattern = item.url.replace(/\{[^\}]+\}/g, "([^/]+)");
            const regex = new RegExp(`^${pattern}$`);
            if (regex.test(compareId)) {
              // showYn이 'N'이면 부모 메뉴를 찾아서 반환
              if (item.showYn == "N") {
                // this.menuList.children 전체에서 부모 ID로 검색 (재귀 호출 재사용)
                const parent = this.getFindMenu(this.menuList.children, "id", item.parentId);
                if (parent) return parent;
              }
              return item;
            }
          }
        }
        // 3. 자식 메뉴 재귀 탐색
        if (item.children) {
          const found = this.getFindMenu(item.children, type, compareId);
          if (found) return found;
        }
      }
      return null;
    },
    getFindChildMenu(menu, compareId, list) {
      menu.map((item) => {
        if (item.parentId == parseInt(compareId) && item.level != 1 && item.showYn == "Y") {
          list.push(item);
        }

        if (item.children != null) {
          this.getFindChildMenu(item.children, compareId, list);
        }
      });
    },
    loadCss: function (url) {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = url;
      document.head.appendChild(file);
    },
    loadJs: function (url, async = true) {
      let file = document.createElement("script");
      file.setAttribute("src", url);
      file.async = async;
      document.head.appendChild(file);
      return file;
    },
  },
};
</script>
